module.exports = __webpack_public_path__ + "static/media/Image_banner.47160727.webp";